// extracted by mini-css-extract-plugin
export var carrierNotice = "_jw-5";
export var carrierNoticePlaceholder = "_jw-6";
export var deliveryRow = "_jw-c";
export var fixedHeight = "_jw-4";
export var freightLogo = "_jw-b";
export var fullWidth = "_jw-3";
export var priceColumn = "_jw-7";
export var radioSelected = "_jw-9";
export var radioUnselected = "_jw-8";
export var selectedOption = "_jw-2";
export var selectedOptionContainer = "_jw-1";
export var selection = "_jw-0";
export var tallSkeletonText = "_jw-a";